const Title = ({ children, styleClass = "mb-3" }) => {
  return (
    <h1 className={styleClass}>
      <b>{children}</b>
    </h1>
  );
};

export default Title;
